import PropTypes from 'prop-types';
import React from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@mui/material';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import { useRedirectToAssignResource } from '~/modules/resourcing/hooks';

const useStyles = makeStyles(theme => ({
  alternative: {
    marginTop: theme.spacing(1.75)
  },
  uppercaseText: {
    textTransform: 'uppercase',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));

export const ResourceMatchAlternativeLink = ({
  scale,
  displayUnit,
  resourceRequest
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { pathname } = useLocation();
  const isResourcingTab = Boolean(matchPath(pathname, { path: '/resourcing' }));
  const onAssignResourceAction = useRedirectToAssignResource({
    history,
    resourceRequest,
    isResourcingTab,
    scale,
    displayUnit
  });

  return (
    <div
      data-qe-id="ResourceMatchAlternativeLink"
      className={classes.alternative}
    >
      <Button
        className={classes.uppercaseText}
        onClick={onAssignResourceAction}
        variant="text"
        size="small"
        color="primary"
      >
        <Typography variant="button" color="primary">
          {formatMessage({
            id: 'resourceMatchPopover.moreAlternatives'
          })}
        </Typography>
      </Button>
    </div>
  );
};

ResourceMatchAlternativeLink.propTypes = {
  resourceRequest: PropTypes.object.isRequired,
  scale: PropTypes.oneOf([
    PERIOD_SCALE_ENUM.DAYS,
    PERIOD_SCALE_ENUM.MONTHS,
    PERIOD_SCALE_ENUM.YEARS,
    PERIOD_SCALE_ENUM.QUARTERS,
    PERIOD_SCALE_ENUM.WEEKS,
    PERIOD_SCALE_ENUM.ENTIRE_PROJECT
  ]),
  displayUnit: PropTypes.oneOf([
    DISPLAY_UNIT_ENUM.HOURS,
    DISPLAY_UNIT_ENUM.PERCENTAGE
  ])
};

export default ResourceMatchAlternativeLink;
